import * as actions from './actions';

const initialState = {
  available: true,
  loading: false,
  error: null,
  initial: false,
  // Free results
  reading: null,
  // Premium results
  premiumData: null,
  premiumLoading: false,
  premiumPending: false,
  premiumEtaAt: null,
  synastry: null,
  // Catalog
  planets: [],
  // Feedback
  readingEvaluated: false,
  // Standalone synastry
  standaloneSynastry: null,
  standaloneSynastryLoading: false,
  standaloneSynastryError: null,
  // Anonymous checkout / pay-to-generate (contrato de PayToGenerateFlow)
  pendingReadingId: null,
  pendingLoading: false,
  pendingFullName: null,
  checkoutLoading: false,
  checkoutError: null,
  purchaseVerified: false,
  paidReadingId: null,
  paidEmail: null,
  paidReading: null,
};

export default function astralChartReducer(state = initialState, action) {
  switch (action.type) {
    // Availability
    case actions.ASTRAL_AVAILABILITY_REQUEST:
      return { ...state, loading: true, error: null };
    case actions.ASTRAL_AVAILABILITY_SUCCESS:
      return { ...state, available: action.payload.available, loading: false, initial: true, error: null };
    case actions.ASTRAL_AVAILABILITY_ERROR:
      return { ...state, loading: false, error: action.payload };

    // Calculate
    case actions.ASTRAL_CALCULATE_REQUEST:
      return { ...state, loading: true, error: null, reading: null };
    case actions.ASTRAL_CALCULATE_SUCCESS:
      return { ...state, reading: action.payload.reading, loading: false, error: null };
    case actions.ASTRAL_CALCULATE_ERROR:
      return { ...state, loading: false, error: action.payload };

    // Premium
    case actions.ASTRAL_PREMIUM_REQUEST:
      return { ...state, premiumLoading: true, premiumPending: false, premiumEtaAt: null, error: null };
    case actions.ASTRAL_PREMIUM_SUCCESS:
      return { ...state, premiumData: action.payload.data, premiumLoading: false, premiumPending: false, error: null };
    case actions.ASTRAL_PREMIUM_PENDING:
      return { ...state, premiumPending: true, premiumEtaAt: action.payload.etaAt, premiumData: null, premiumLoading: false, error: null };
    case actions.ASTRAL_PREMIUM_ERROR:
      return { ...state, premiumLoading: false, error: action.payload };

    // Synastry
    case actions.ASTRAL_SYNASTRY_REQUEST:
      return { ...state, premiumLoading: true, error: null };
    case actions.ASTRAL_SYNASTRY_SUCCESS:
      return { ...state, synastry: action.payload.data, premiumLoading: false, error: null };
    case actions.ASTRAL_SYNASTRY_ERROR:
      return { ...state, premiumLoading: false, error: action.payload };

    // Like
    case actions.ASTRAL_LIKE_REQUEST:
      return { ...state };
    case actions.ASTRAL_LIKE_SUCCESS:
      return { ...state, readingEvaluated: true };

    // Catalog
    case actions.ASTRAL_CATALOG_REQUEST:
      return { ...state, loading: true, error: null };
    case actions.ASTRAL_CATALOG_SUCCESS:
      return { ...state, planets: action.payload.planets, loading: false, error: null };
    case actions.ASTRAL_CATALOG_ERROR:
      return { ...state, loading: false, error: action.payload };

    // Standalone Synastry
    case actions.STANDALONE_SYNASTRY_REQUEST:
      return { ...state, standaloneSynastryLoading: true, standaloneSynastryError: null, standaloneSynastry: null };
    case actions.STANDALONE_SYNASTRY_SUCCESS:
      return { ...state, standaloneSynastry: action.payload.data, standaloneSynastryLoading: false, standaloneSynastryError: null };
    case actions.STANDALONE_SYNASTRY_ERROR:
      return { ...state, standaloneSynastryLoading: false, standaloneSynastryError: action.payload };
    case actions.STANDALONE_SYNASTRY_RESET:
      return { ...state, standaloneSynastry: null, standaloneSynastryLoading: false, standaloneSynastryError: null };

    // Pending reading creation (pay-to-generate landing)
    case actions.CREATE_PENDING_ASTRAL_REQUEST:
      return { ...state, pendingLoading: true, pendingReadingId: null, checkoutError: null };
    case actions.CREATE_PENDING_ASTRAL_SUCCESS:
      return {
        ...state,
        pendingLoading: false,
        pendingReadingId: action.payload.readingId,
        pendingFullName: action.payload.fullName,
      };
    case actions.CREATE_PENDING_ASTRAL_FAILURE:
      return { ...state, pendingLoading: false, checkoutError: action.payload, error: action.payload };

    // Checkout (Stripe + PayPal)
    case actions.ASTRAL_CHECKOUT_REQUEST:
    case actions.ASTRAL_PAYPAL_ORDER_REQUEST:
      return { ...state, checkoutLoading: true, checkoutError: null, error: null };
    case actions.ASTRAL_CHECKOUT_SUCCESS:
    case actions.ASTRAL_PAYPAL_ORDER_SUCCESS:
      return { ...state, checkoutLoading: false };
    case actions.ASTRAL_CHECKOUT_FAILURE:
    case actions.ASTRAL_PAYPAL_ORDER_FAILURE:
      return { ...state, checkoutLoading: false, checkoutError: action.payload, error: action.payload };

    case actions.ASTRAL_VERIFY_PURCHASE_REQUEST:
    case actions.ASTRAL_VERIFY_PAYPAL_REQUEST:
      return { ...state, premiumLoading: true, checkoutLoading: true, error: null };
    case actions.ASTRAL_VERIFY_PURCHASE_SUCCESS:
    case actions.ASTRAL_VERIFY_PAYPAL_SUCCESS:
      return {
        ...state,
        premiumLoading: false,
        checkoutLoading: false,
        purchaseVerified: true,
        paidReadingId: action.payload.reading_id,
        paidEmail: action.payload.email,
        reading: action.payload.reading || state.reading,
        paidReading: action.payload.reading || state.paidReading,
        premiumData: action.payload.premium || state.premiumData,
      };
    case actions.ASTRAL_VERIFY_PURCHASE_FAILURE:
    case actions.ASTRAL_VERIFY_PAYPAL_FAILURE:
      return { ...state, premiumLoading: false, checkoutLoading: false, checkoutError: action.payload, error: action.payload };

    // Reset
    case actions.ASTRAL_RESET:
      return { ...initialState };

    default:
      return state;
  }
}
